// Sits inside the existing /projects/:id route. When the demo flag is on for
// this user and the id is one of the three demo cards, renders the ArcDisk
// project page; otherwise renders Mosaico's own project view untouched (a demo
// id waits for the flags to load first, so a reload never flashes Mosaico's
// view for an id it does not know). Keeping the gate
// inside the route means the ProtectedRoute (auth + profile check) above it
// still applies to the demo pages.
import type { ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import { useArcDiskDemoEnabled, useArcDiskDemoLoading } from '../useArcDiskDemo'
import { isDemoProjectCardId } from '../data/projects'
import { ArcDiskProjectPage } from './ArcDiskProjectPage'

export const ArcDiskProjectRouteGate = ({ children }: { children: ReactElement }) => {
  const { id } = useParams()
  const enabled = useArcDiskDemoEnabled()
  const loading = useArcDiskDemoLoading()
  if (!isDemoProjectCardId(id)) return children
  if (loading) return null
  return enabled ? <ArcDiskProjectPage /> : children
}
